export {
  STATEFUL_CONNECT_MODAL_ID,
  CONNECT_WALLETS_MODAL_ID,
  PROFILE_WALLETS_MODAL_ID,
} from '@rango-dev/internal-profile/constants';
export const WALLET_DETAILS_MODAL_ID = 'wallet-details-modal';
